<div
  *ngIf="data && data.length && _visibleColumns.length"
  [class]="'table-container '+cssClass"
>
  <iv-live-header
    [row]="header"
    class="table-header"
    style="display: flex;flex-direction: row"
  ></iv-live-header>

  <div class="table-body-container">
    <cdk-virtual-scroll-viewport
      (scroll)="onTableScroll($event)"
      [maxBufferPx]="maxBufferPx"
      [minBufferPx]="scrollBuffer"
      class="table-body"
      itemSize="27"
    >
      <div
        *cdkVirtualFor="let row of data; index as i; trackBy: trackByFn;"
        [attr.data-index]="i"
        [class.center]="(row) && (row.call_pos === 0 || row.put_pos === 0 || row.pos === 0)"
        [class.expiration]="(row) && row.type=='expiration'"
        [class.selected]="(row) && row.selected"
        class="table-row"
      >
        <ng-container *ngIf="(row) &&  row.type=='expiration'">
          <iv-live-image-button
            (buttonClicked)="onExpirationButtonClick($event)"
            [data]="row.expiration"
            style="margin-left: 10px;"
          >
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYNJREFUeNpiZFjXMJ+BgSGBgTZgAQPQgv9ALECKrt6pKxwIKgKZCTSbCcwJavhAguEBQGo+QYVQM5nI8HY+ECtALSIIWEgMGlBQXgBikOsUiNMFigMSAdCiBmLNZmKgMWBBsq0fSBpgUXMBGGGFBFwK0lcPxLDUWAjUcwE9DkCKsCU/B6ABF4EaFuCxYj6a4wSwRXIhsgQU+ANxARDHQzINVtc7QA0HRXwg3NcYFkC9hKb5AjSXO4ANCmo4gMWKeniuxSLPRERmmQjl9eNwPSxYJ2IzgphUNAHqfQNoQkAUBQwM6+FqghoekGcBxBewVFQANLjgCesPeSB7PzTOQAY3UpaTQSloXYM9ND76+0XgjoVELLTcgRaCILygODsCrIgRnJODGhiBkgmEsv8pro/+h7neG7xn/s2g85OHwear4AKZ3xwPkZTwQ1MdONiKJW8UULWoAPkAiM9DHQs2m4WaxQIwWEDJ1JDUVEQRGLWASAtIrPSB4ABRlT40H9C02QIQYABij4dWJaCjjQAAAABJRU5ErkJggg=="
            />
          </iv-live-image-button>

          <span>Expiry: {{row.expiration}}</span>
          <span style="margin-left: 20px;">Days: {{row.days ? row.days : 0}}</span>

          <span
            *ngIf="row.forward"
            class="with-tip"
            style="margin-left: 20px;"
          >Forward: {{row.forward}}
            <span class="tip">
              Agreed upon price of asset in forward contract. Forward price accounts for interest and dividends to be paid
            </span>
          </span>

          <span
            *ngIf="row.forward_eod"
            class="with-tip"
            style="margin-left: 20px;"
          >Forward (EOD): {{row.forward_eod}}
            <span class="tip">
              Agreed upon price of asset in forward contract. Forward price accounts for interest and dividends to be paid
            </span>
          </span>
        </ng-container>

        <ng-container *ngIf="(row) && row.type=='row'">
          <div
            *ngFor="let column of header"
            [attr.data-index]="i"
            [ngSwitch]="column.template"
            [style.width.px]="(column.width)"
            class="{{column.dataField}}_cell_row"
          >
            <ng-container *ngSwitchDefault>
              {{row[column.dataField]}}
            </ng-container>

            <ng-container *ngSwitchCase="'optionSymbol'">
              <div class="symbol">
                <span
                  tuiHintMode="onDark"
                  tuiHintDirection="bottom-left"
                  [tuiHint]="row[column.dataField]"
                >
                  {{row[column.dataField]}}
                </span>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'date'">
              {{row[column.dataField] | date:'MM/dd/yyyy'}}
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
              {{ ((row[column.dataField] != 'NaN'
              && row[column.dataField] != 'Infinity'
              && row[column.dataField] != '-Infinity') ?
              (row[column.dataField] !== null ? row[column.dataField] : 0) : null) | number: column.rounding ? column.rounding : '1.0-2'}}
            </ng-container>

            <ng-container *ngSwitchCase="'iv'">
              {{ ((row[column.dataField] != 'NaN'
              && row[column.dataField] != 'Infinity'
              && row[column.dataField] != '-Infinity' && row[column.dataField] != -100) ? row[column.dataField] : null) | number:'1.0-2'}}
            </ng-container>

            <ng-container *ngSwitchCase="'mean'">
              {{ ((row[column.dataField] != 'NaN'
              && row[column.dataField] != 'Infinity'
              && row[column.dataField] != '-Infinity') ? row[column.dataField] : null) | number:'1.0-3'}}
            </ng-container>

            <ng-container *ngSwitchCase="'strike'">
              <iv-live-image-button
                (buttonClicked)="onStrikeButtonClick($event)"
                [data]="row[column.dataField]"
                tuiHintMode="onDark"
                tuiHintDirection="bottom-left"
                [tuiHint]="'Time Skew'"
              >
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYNJREFUeNpiZFjXMJ+BgSGBgTZgAQPQgv9ALECKrt6pKxwIKgKZCTSbCcwJavhAguEBQGo+QYVQM5nI8HY+ECtALSIIWEgMGlBQXgBikOsUiNMFigMSAdCiBmLNZmKgMWBBsq0fSBpgUXMBGGGFBFwK0lcPxLDUWAjUcwE9DkCKsCU/B6ABF4EaFuCxYj6a4wSwRXIhsgQU+ANxARDHQzINVtc7QA0HRXwg3NcYFkC9hKb5AjSXO4ANCmo4gMWKeniuxSLPRERmmQjl9eNwPSxYJ2IzgphUNAHqfQNoQkAUBQwM6+FqghoekGcBxBewVFQANLjgCesPeSB7PzTOQAY3UpaTQSloXYM9ND76+0XgjoVELLTcgRaCILygODsCrIgRnJODGhiBkgmEsv8pro/+h7neG7xn/s2g85OHwear4AKZ3xwPkZTwQ1MdONiKJW8UULWoAPkAiM9DHQs2m4WaxQIwWEDJ1JDUVEQRGLWASAtIrPSB4ABRlT40H9C02QIQYABij4dWJaCjjQAAAABJRU5ErkJggg=="
                />
              </iv-live-image-button>
              <iv-live-image-button
                  *ngIf="!isFutures && instrument.regionId === 1"
                  (click)="openContractViewer(row, row[column.dataField])"
                  statistic
                  statisticElementName="Click contract viewer Option Chain (Price and IV history charts)"
                  tuiHintMode="onDark"
                  tuiHintDirection="bottom-left"
                  [tuiHint]="'Price and IV history charts'"
                >
                  <img
                    class="contract-viewer-image"
                    src="../../../../iv-live/assets/icons/Price-and-iv-chart-icon.svg"
                  >
                </iv-live-image-button>
              <span>{{row[column.dataField]| number:'1.0-4'}}</span>

              <ng-container *ngIf="instrument.regionId !== 2 && instrument.regionId != 3">
                <iv-live-image-button
                  (buttonClicked)="onCalculatorButtonClick(row)"
                  statistic
                  statisticElementName="Click Option Monitor calculator button"
                  id="calculatorButton"
                  style="margin-left: 10px;"
                >
                  <img
                    src="data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABlQAAAZUBDE2OiAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACxSURBVEiJ7ZPLDcIwEESfUbpACEE93EIRudDD1pBDuoBjyskFQRvLIUIQbxLnJwVLzM2j9e7Mjg2xwxnmJieUHDiM7FWhXDhL+U1uTJlSTGgOcMRR+GTSUrgDIBXrrg9XUWDv09bBwoh/QFsGNeqdzsbKK0rFNV5T6Dx6wAKw0+fu3nP0zyCI+DPo/snwUfN21bXvHterOHgAW8AqC+dz9wnrwJEBz4ECm8KUbMK9H8cL0RIuy8jrs/gAAAAASUVORK5CYII=
      "
                  >
                </iv-live-image-button>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'quoteTime'">
              {{getQuoteTime(row[column.dataField])}}
            </ng-container>

            <ng-container *ngSwitchCase="'valueChange'">
              <iv-live-cell
                [change]="row[column.dataField]"
                [requestId]="getTrackValue(row)"
                [showChangeValue]="true"
              >
                {{ ((row[column.dataField] != 'NaN'
                && row[column.dataField] != 'Infinity'
                && row[column.dataField] != '-Infinity') ?
                (row[column.dataField] !== null ? row[column.dataField] : 0) : null) | number:'1.0-2'}}
              </iv-live-cell>
            </ng-container>

            <ng-container *ngSwitchCase="'backgroundChange'">
              <iv-live-cell
                [requestId]="getTrackValue(row)"
                [showChangeBackground]="true"
                [value]="row[column.dataField]"
              >
                {{ ((row[column.dataField] != 'NaN'
                && row[column.dataField] != 'Infinity'
                && row[column.dataField] != '-Infinity') ?
                (row[column.dataField] !== null ? row[column.dataField] : 0) : null) | number:'1.0-2'}}
              </iv-live-cell>
            </ng-container>

            <ng-container *ngSwitchCase="'ivint'">
              {{row['iv']}}
              <ng-container *ngIf="row[column.type+'_iv'] > -1">
                {{row[column.dataField] | number:'1.0-2'}}
              </ng-container>
              <ng-container *ngIf="row[column.type+'_iv'] <= -1">
                 <span class="with-tip">
                {{ row[column.dataField] | number:'1.0-2'}}*
                    <span class="tip">
                      Implied Volatility value is derived by IVolatilty.com. Interpolation is done if no IV calculation was possible from activity.
                    </span>
                  </span>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'ivint_eod'">
              <ng-container *ngIf="row[column.type+'_iv_eod'] > -100">
                {{row[column.type + '_iv_eod'] | number:'1.0-2'}}
              </ng-container>
              <ng-container *ngIf="row[column.type+'_iv_eod'] <= -100">
                 <span class="with-tip">
                {{row[column.type + '_iv_eod'] | number:'1.0-2'}}*
                    <span class="tip">
                      Implied Volatility value is derived by IVolatilty.com. Interpolation is done if no IV calculation was possible from activity.
                    </span>
                  </span>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'style'">
              {{row[column.dataField] | style}}
            </ng-container>

          </div>
        </ng-container>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<dx-popup
  [(visible)]="calculatorsPopupPopupVisible"
  [dragEnabled]="true"
  [height]="calculatorType === 'options' ? isFutures ? 520 : 600 : 464"
  [maxHeight]="600"
  [shading]="false"
  [showTitle]="true"
  [showCloseButton]="true"
  [closeOnOutsideClick]="true"
  [focusStateEnabled]="true"
  [width]="900"
  class="create-popup"
  titleTemplate="title"
>
  <div
    *dxTemplate="let data of 'title'"
    style="background-color: #272B29;width: 100%;display: block; padding: 0 16px; border: none; border-radius: 16px 16px 0 0"
  >
    <iv-live-common-calculator-header
      [userPermissionMode]="mode"
      [isControlsShown]="+sessionStorage.getItem('currentStockRegion') === 1"
      [isEod]="isEODOptions && isEODProbability"
      (switchMode)="switchCalculatorMode()"
      (switchType)="switchCalculatorType($event)"
      (closeCalculator)="calculatorsPopupPopupVisible = false"
      [isFutures]="tabType === tabTypeEnum.FUTURES_OPTION_CHAIN"
      style="position: relative; top: 16px;"
    >
    </iv-live-common-calculator-header>
  </div>
  <div *dxTemplate="let data of 'content'">
    <div style="background-color: #272B29;padding:16px;height: 100%; border-radius: 0 0 16px 16px; margin-top: -1px">
      <iv-live-options-calculator
        *ngIf="tabType === tabTypeEnum.OPTION_CHAIN && calculatorsPopupPopupVisible"
        [ngStyle]="{'display': calculatorType === 'options' ? 'inline' : 'none'}"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionOptions($event.region)"
        (showMessageEvent)="showMessage($event)"
        (onInstrumentChange)="selectedInstrument = $event"
        [instrument]="selectedInstrument"
        [instruments]="instruments"
        [mode]="mode"
      ></iv-live-options-calculator>
      <iv-live-futures-calculator
        *ngIf="tabType === tabTypeEnum.FUTURES_OPTION_CHAIN && calculatorsPopupPopupVisible"
        [ngStyle]="{'display': calculatorType === 'options' ? 'inline' : 'none'}"
        [future]="selectedInstrument"
        [futures]="instruments"
        [mode]="mode"
        [currentTab]="currentTab"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionOptions($event.region)"
        (showMessageEvent)="showMessage($event)"
        (onFutureChange)="selectedInstrument = $event"
      >
      </iv-live-futures-calculator>
      <iv-live-probability-calculator
        *ngIf="calculatorsPopupPopupVisible"
        [ngStyle]="{'display': calculatorType === 'probability' ? 'inline' : 'none'}"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionProbability($event.region)"
        (showMessageEvent)="showMessage($event)"
        (onInstrumentChange)="selectedInstrument = $event"
        [instrument]="selectedInstrument"
        [instruments]="instruments"
        [mode]="mode"
        [currentTab]="currentTab"
      ></iv-live-probability-calculator>
    </div>
  </div>
</dx-popup>

<div
  *ngIf="!data || !data.length"
  style="padding: 10px; text-align: center;"
>
  {{emptyMessage}}
</div>
